"use client";

import routes from "@/app.route";
import Logo from "./logo";
import Link from "next/link";
import Announcement from "./announcement";
import { useMediaQuery } from "@mui/material";
import { usePathname } from "next/navigation";
import useSession from "@/hooks/session";

export default function HeaderSlim() {
  const matches = useMediaQuery("(min-width:1024px)");
  const pathname = usePathname();
  const { customer } = useSession();

  return (
    <>
      <header>
        {matches && <Announcement />}
        <div className="bg-white border-b border-zinc-200">
          <div className="w-full max-w-8xl mx-auto px-2 md:px-4 h-[60px] flex items-center">
            <div className="flex flex-1 justify-between items-center gap-4 h-full">
              <figure>
                <Logo className="w-48" />
              </figure>
              <div className="divide-x divide-zinc-500">
                {!customer && (
                  <Link
                    href={`${routes.login.url}?ret=${pathname}`}
                    className="text-sm text-zinc-500 px-2 md:px-4 hover:underline"
                  >
                    Sign In
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
